<template>

    <div id="preCourses">

        <v-container fluid>
            <v-card flat>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="headline">Portal URLS</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                    label="Attendee Pre-Course URL"
                                    :value="model.attendeePreCourseUrl"
                                    readonly
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                    label="Trainer Pre-Course URL"
                                    :value="model.trainerPreCourseUrl"
                                    readonly
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-row>
                <v-col cols="6" v-for="preCourse in model.precourseQuestionnaires" :key="preCourse.id">
                    <v-card>
                        <v-list-item>
                            <v-list-item-avatar color="cyan lighten-4">{{getInitials(preCourse)}}</v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title class="headline">{{preCourse.firstName}} {{preCourse.lastName}}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ preCourse.organization }}
                                    <span v-if="preCourse.organization && preCourse.jobTitle"> - </span>
                                    {{preCourse.jobTitle}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-card-text v-if="preCourse.email">
                            <v-chip-group>
                                <v-chip color="primary" label>
                                    <v-avatar left>
                                        <v-icon>mdi-email</v-icon>
                                    </v-avatar>
                                    {{ preCourse.email }}
                                </v-chip>
                            </v-chip-group>
                        </v-card-text>
                        <v-list subheader>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="headline">General Questions</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>Have you seen the course outline?</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon color="green" v-if="preCourse.answer5">mdi-check</v-icon>
                                    <v-icon color="red" v-else>mdi-close</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>Do you meet the pre-requisites of the course?</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon color="green" v-if="preCourse.answer6">mdi-check</v-icon>
                                    <v-icon color="red" v-else>mdi-close</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>If attending a higher level course have you attended the previous
                                        level?
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-icon color="green" v-if="preCourse.answer7">mdi-check</v-icon>
                                    <v-icon color="red" v-else>mdi-close</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title class="headline">Software Question</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>Are you using the software at moment?</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-chip color="primary" label>{{mapAnswer4(preCourse.answer4)}}</v-chip>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>Windows PC or Mac?</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-chip color="primary" label>{{mapAnswer1(preCourse.answer1)}}</v-chip>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>

                        <v-card-text>

                            <v-textarea
                                    class="mx-2"
                                    label="Most useful topics"
                                    rows="5"
                                    outlined
                                    readonly
                                    :value="preCourse.mostUsefulTopics"
                            ></v-textarea>
                            <v-textarea
                                    class="mx-2"
                                    label="Main Tasks"
                                    rows="5"
                                    outlined
                                    readonly
                                    :value="preCourse.mainTasks"
                            ></v-textarea>
                            <v-textarea
                                    class="mx-2"
                                    label="Comments"
                                    rows="5"
                                    outlined
                                    readonly
                                    :value="preCourse.comments"
                            ></v-textarea>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>

</template>

<script>

    export default {

        props: {
            model: Object,
        },

        methods: {

            mapAnswer4(number) {
                const map = ['Regularly', 'Occasionally', 'Used older version', 'Not at all']
                return map[number - 1]
            },
            mapAnswer1(number) {
                const map = ['Windows', 'Mac', 'Other', 'None']
                return map[number - 1]
            },

            getInitials(preCourse) {
                const initals = preCourse.firstName.charAt(0) + preCourse.lastName.charAt(0)
                return initals.toUpperCase()
            }


        }


    }

</script>